import React from 'react';
import currencyFormatter from 'currency-formatter';

interface MoneyProps {
  value: number;
}

export const moneyFormat = (value: number): string => {
  return currencyFormatter.format(value, { code: 'EUR' });
};

const Money = ({ value }: MoneyProps) => {
  return <span dangerouslySetInnerHTML={{ __html: currencyFormatter.format(value, { code: 'EUR', precision: 0 }) }} />;
};

export default Money;
